import { CALL_API, Schemas } from '../../common/middleware/api';

export const INSTALMENT_PLAN_TEMPLATES_REQUEST = 'INSTALMENT_PLAN_TEMPLATES_REQUEST';
export const INSTALMENT_PLAN_TEMPLATES_SUCCESS = 'INSTALMENT_PLAN_TEMPLATES_SUCCESS';
export const INSTALMENT_PLAN_TEMPLATES_FAILURE = 'INSTALMENT_PLAN_TEMPLATES_FAILURE';

export const INSTALMENT_PLAN_TEMPLATE_FETCH_REQUEST = 'INSTALMENT_PLAN_TEMPLATE_GET_REQUEST';
export const INSTALMENT_PLAN_TEMPLATE_FETCH_SUCCESS = 'INSTALMENT_PLAN_TEMPLATE_GET_SUCCESS';
export const INSTALMENT_PLAN_TEMPLATE_FETCH_FAILURE = 'INSTALMENT_PLAN_TEMPLATE_GET_FAILURE';

export const INSTALMENT_PLAN_TEMPLATE_CREATE_REQUEST = 'INSTALMENT_PLAN_TEMPLATE_CREATE_REQUEST';
export const INSTALMENT_PLAN_TEMPLATE_CREATE_SUCCESS = 'INSTALMENT_PLAN_TEMPLATE_CREATE_SUCCESS';
export const INSTALMENT_PLAN_TEMPLATE_CREATE_FAILURE = 'INSTALMENT_PLAN_TEMPLATE_CREATE_FAILURE';

export const INSTALMENT_PLAN_TEMPLATE_UPDATE_REQUEST = 'INSTALMENT_PLAN_TEMPLATE_UPDATE_REQUEST';
export const INSTALMENT_PLAN_TEMPLATE_UPDATE_SUCCESS = 'INSTALMENT_PLAN_TEMPLATE_UPDATE_SUCCESS';
export const INSTALMENT_PLAN_TEMPLATE_UPDATE_FAILURE = 'INSTALMENT_PLAN_TEMPLATE_UPDATE_FAILURE';

export const INSTALMENT_PLAN_TEMPLATE_DELETE_REQUEST = 'INSTALMENT_PLAN_TEMPLATE_DELETE_REQUEST';
export const INSTALMENT_PLAN_TEMPLATE_DELETE_SUCCESS = 'INSTALMENT_PLAN_TEMPLATE_DELETE_SUCCESS';
export const INSTALMENT_PLAN_TEMPLATE_DELETE_FAILURE = 'INSTALMENT_PLAN_TEMPLATE_DELETE_FAILURE';

export const loadInstalmentPlanTemplates = (options) => ({
	[CALL_API]: {
		types: [INSTALMENT_PLAN_TEMPLATES_REQUEST, INSTALMENT_PLAN_TEMPLATES_SUCCESS, INSTALMENT_PLAN_TEMPLATES_FAILURE],
		endpoint: 'api/instalmentPlanTemplates',
		request: options,
		schema: Schemas.INSTALMENT_PLAN_TEMPLATE_ARRAY
	}
});

export const fetchInstalmentPlanTemplate = (id) => ({
	[CALL_API]: {
		types: [INSTALMENT_PLAN_TEMPLATE_FETCH_REQUEST, INSTALMENT_PLAN_TEMPLATE_FETCH_SUCCESS, INSTALMENT_PLAN_TEMPLATE_FETCH_FAILURE],
		endpoint: `api/instalmentPlanTemplates/${id}`,
		schema: Schemas.INSTALMENT_PLAN_TEMPLATE
	}
});

export const createInstalmentPlanTemplate = (instalmentPlanTemplate, history) => ({
	[CALL_API]: {
		types: [INSTALMENT_PLAN_TEMPLATE_CREATE_REQUEST, INSTALMENT_PLAN_TEMPLATE_CREATE_SUCCESS, INSTALMENT_PLAN_TEMPLATE_CREATE_FAILURE],
		endpoint: 'api/instalmentPlanTemplates',
		method: 'POST',
		request: instalmentPlanTemplate,
		schema: Schemas.INSTALMENT_PLAN_TEMPLATE,
		form: 'instalmentPlanTemplate',
		transition: {
			history,
			successPath: (response) => {
				return `/instalmentPlans/${response.result}`;
			}
		}
	}
});

export const updateInstalmentPlanTemplate = (id, instalmentPlanTemplate) => ({
	[CALL_API]: {
		types: [INSTALMENT_PLAN_TEMPLATE_UPDATE_REQUEST, INSTALMENT_PLAN_TEMPLATE_UPDATE_SUCCESS, INSTALMENT_PLAN_TEMPLATE_UPDATE_FAILURE],
		endpoint: `api/instalmentPlanTemplates/${id}`,
		method: 'PUT',
		request: instalmentPlanTemplate,
		schema: Schemas.INSTALMENT_PLAN_TEMPLATE,
		form: 'instalmentPlanTemplate'
	}
});

export const deleteInstalmentPlanTemplate = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [
			INSTALMENT_PLAN_TEMPLATE_DELETE_REQUEST,
			INSTALMENT_PLAN_TEMPLATE_DELETE_SUCCESS,
			INSTALMENT_PLAN_TEMPLATE_DELETE_FAILURE
		],
		endpoint: `api/instalmentPlanTemplates/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});